var _path, _circle, _g, _path2, _path3, _path4, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankYouGraffiti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 241,
    viewBox: "0 0 273 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.132 50.1581C237.041 50.9271 253.584 48.3786 256.485 32.0331C259.385 15.6875 267.14 11.1617 270.656 10.942",
    stroke: "#F3603F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.897,
    cy: 116.831,
    r: 79.0761,
    fill: "#53B175"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_178_767)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 158.897,
    cy: 116.831,
    r: 68.1416,
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.038 99.5319C194.038 101.685 193.193 103.764 191.656 105.249L155.94 139.848C154.327 141.333 152.176 142.224 149.949 142.224C147.721 142.224 145.57 141.333 144.034 139.848L126.137 122.548C124.601 121.063 123.756 118.985 123.756 116.831C123.756 114.678 124.678 112.674 126.214 111.114C127.827 109.629 129.901 108.813 132.129 108.739C134.356 108.739 136.43 109.555 138.043 111.04L149.949 122.548L179.751 93.7406C181.364 92.2557 183.438 91.439 185.665 91.439C187.893 91.5132 189.967 92.33 191.58 93.8891C193.116 95.3741 194.038 97.3787 194.038 99.5319Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.104 195.908C225.486 198.04 239.758 206.144 237.789 221.498",
    stroke: "#F7B23B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57764 174.24C12.9059 178.506 37.3279 181.566 44.3898 159.675M44.3898 159.675C45.4197 153.643 44.39 141.711 32.0319 142.241C29.6778 148.052 28.8538 159.675 44.3898 159.675ZM44.3898 159.675C49.5391 160.631 61.5148 159.719 68.2235 148.42",
    stroke: "#6E89FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.348,
    cy: 232.727,
    r: 7.57962,
    fill: "#637BFE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.002,
    cy: 112.7,
    r: 7.07962,
    stroke: "#C05EFD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.684,
    cy: 8.30033,
    r: 8.30033,
    fill: "#53B175"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.251,
    cy: 22.3102,
    r: 4.38348,
    fill: "#F3603F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.6366,
    cy: 86.6854,
    r: 7.18199,
    stroke: "#F7B23B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.2814,
    cy: 207.816,
    r: 7.94695,
    stroke: "#53B175"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.03543,
    cy: 4.03543,
    r: 4.03543,
    transform: "matrix(-1 0 0 1 161.816 220)",
    fill: "#53B175"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_178_767",
    x: 85.7554,
    y: 46.6898,
    width: 146.283,
    height: 146.283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_178_767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_178_767",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouGraffiti);
export default __webpack_public_path__ + "static/media/thank_you_graffiti.dd9cdd808bda73549a1edb0dfb6886b3.svg";
export { ForwardRef as ReactComponent };